import { render, staticRenderFns } from "./AccountStatementCard.vue?vue&type=template&id=60aea167&scoped=true"
import script from "./AccountStatementCard.vue?vue&type=script&lang=js"
export * from "./AccountStatementCard.vue?vue&type=script&lang=js"
import style0 from "./AccountStatementCard.vue?vue&type=style&index=0&id=60aea167&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aea167",
  null
  
)

export default component.exports